import { all } from 'redux-saga/effects'

import { submitSaga } from './submit/saga'
import { bulkInviteSaga } from './bulk-invite/saga'

export function* inviteSaga() {
  yield all([submitSaga(), bulkInviteSaga()])
}
